import {
  Component,
} from 'preact';

import {
  Logo,
} from './logo';
import {
  NavigationLink,
} from './navigationlink';
import {
  VersionMenu,
} from './versionmenu';

class Sidebar extends Component {
  getItemPermissions = (item) => {
    let itemPermissions = item.Permissions ? item.Permissions : [];
    itemPermissions = itemPermissions.concat(...(this.getSubItemPermissions(item)))
    return itemPermissions;
  }

  getSubItemPermissions = (item) => {
    return item.SubItems ? item.SubItems.map(s => {
      let subItemPermissions = s.Permissions ? s.Permissions : [];
      return subItemPermissions.concat(...this.getFinalItemPermissions(s));
    }) : []
  }

  getFinalItemPermissions = (subItem) => {
    return subItem.FinalItems ? subItem.FinalItems.map(f => f.Permissions) : []
  }

  // the user has permission to view the item, or any sub item or final item on it
  userHasPermission = (item, account) => {
    const itemPermissions = this.getItemPermissions(item);

    if (!account || !account.Permissions) {
      return false;
    }

    if (!itemPermissions || itemPermissions.length <= 0) {
      return true;
    }

    const currentUserPermissions = account.Permissions;

    // the user must have at least one of the permissions to have access
    const isPermitted = itemPermissions.some((permissionRequired) => {

      // return currentUserPermissions.indexOf(permissionRequired) !== -1
      return (currentUserPermissions.map((permission) => {
        return !permissionRequired || (permission.Action === permissionRequired.Action &&
          permission.Name === permissionRequired.Name &&
          permission.Prefix === permissionRequired.Prefix &&
          permission.UserType === permissionRequired.UserType);
      }).filter(m => m)).length > 0;
    });

    return isPermitted
  }

  render(props, state) {
    let account = props.account;
    let userHasPermission = (item, account) => this.userHasPermission(item, account);

    const listItems = props.menu.map(function (item, index) {
      const hasPermission = userHasPermission(item, account);
      item.quickAccess = [index]
      return (hasPermission &&
        <NavigationLink
          toggleMenuItem={props.toggleMenuItem}
          toggleMenuSubItem={props.toggleMenuSubItem}
          active={props.selected == item.Name}
          item={item}
          navigationCallback={props.navigationCallback}
          openedMenuItems={props.openedMenuItems}
          removeMenuItem={props.removeMenuItem}
          setPathActive={props.setPathActive}
          activatedPath={props.activatedPath}
          account={props.account}>
        </NavigationLink>
      );
    });
    return (
      <div id="sidebar-container">
        <Logo logoUrl={props.logoUrl} authToken={props.authToken}></Logo>
        <div id="menu-items">
          {account &&
            <span>{listItems}</span>
          }
        </div>
        <VersionMenu
          versionMenuOpen={props.versionMenuOpen}
          toggleVersionMenu={props.toggleVersionMenu}
          veyobarVersion={props.veyobarVersion}
          appVersions={props.appVersions}>
        </VersionMenu>
      </div>
    );
  }
}

export { Sidebar };



// WEBPACK FOOTER //
// ./components/sidebar/sidebar.js